import { customPalette } from './customPalette';
import { TypographyFamily, ColorPalette } from '../constants';
import { createTheme } from '@mui/material';

declare module '@mui/material/styles' {
  interface TypographyVariants {
    pageTitle: React.CSSProperties;
    warningOne: React.CSSProperties;
    warningTwo: React.CSSProperties;
  }
  interface TypographyVariantsOptions {
    pageTitle?: React.CSSProperties;
    warningOne?: React.CSSProperties;
    warningTwo?: React.CSSProperties;
  }
}
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    pageTitle: true;
    warningOne: true;
    warningTwo: true;
  }
}

export const customTypography = createTheme({
  ...customPalette,
  typography: {
    fontFamily: [
      TypographyFamily.ARIAL,
      TypographyFamily.NEXA,
      TypographyFamily.SANS_SERIF,
    ].join(','),

    h1: {
      fontFamily: TypographyFamily.NEXA,
      fontStyle: 'normal',
      textTransform: 'none',
      fontWeight: 800,
      fontSize: '28px',
      color: ColorPalette.RAISIN_BLACK,

      [customPalette.breakpoints.down('sm')]: {
        fontSize: '20px',
      },
    },

    h2: {
      fontFamily: TypographyFamily.ARIAL,
      fontSize: '24px',
      lineHeight: '28px',
      fontWeight: 700,
      fontStyle: 'normal',
      background: ColorPalette.GRADIENT_ONE,
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
    },

    h3: {
      fontFamily: TypographyFamily.NEXA,
      fontStyle: 'normal',
      fontWeight: 800,
      fontSize: '20px',
      lineHeight: '24px',
      color: ColorPalette.RAISIN_BLACK,

      [customPalette.breakpoints.down('sm')]: {
        fontSize: '16px',
      },
    },

    h4: {
      fontFamily: TypographyFamily.ARIAL,
      fontSize: '20px',
      fontWeight: 700,
      color: ColorPalette.RAISIN_BLACK,

      [customPalette.breakpoints.down('sm')]: {
        fontSize: '16px',
      },
    },

    h5: {
      fontFamily: TypographyFamily.ARIAL,
      fontSize: '20px',
      fontWeight: 700,
      color: ColorPalette.DARK_GRAY,

      [customPalette.breakpoints.down('sm')]: {
        fontSize: '16px',
      },
    },

    h6: {
      fontFamily: TypographyFamily.ARIAL,
      fontSize: '18px',
      fontWeight: 400,
      color: ColorPalette.RAISIN_BLACK,

      [customPalette.breakpoints.down('sm')]: {
        fontSize: '14px',
      },
    },

    body1: {
      fontFamily: TypographyFamily.ARIAL,
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '24px',
      color: ColorPalette.DARK_GRAY,

      [customPalette.breakpoints.down('sm')]: {
        fontSize: '16px',
      },
    },

    body2: {
      fontFamily: TypographyFamily.ARIAL,
      fontSize: '16px',
      fontWeight: 700,
      lineHeight: '18px',
      color: ColorPalette.DARK_GRAY,
    },

    subtitle1: {
      color: ColorPalette.WHITE,
      fontFamily: TypographyFamily.NEXA,
      fontStyle: 'normal',
      fontWeight: 800,
      fontSize: '20px',

      [customPalette.breakpoints.down('sm')]: {
        fontSize: '18px',
      },
    },

    pageTitle: {
      fontFamily: TypographyFamily.NEXA,
      fontSize: '20px',
      fontWeight: 800,
      background: ColorPalette.GRADIENT_ONE,
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      lineHeight: '24px',
    },

    warningOne: {
      fontFamily: TypographyFamily.NEXA,
      fontSize: '18px',
      fontWeight: 700,
      lineHeight: '18px',
      color: ColorPalette.WARNING_RED,

      [customPalette.breakpoints.down('sm')]: {
        fontSize: '14px',
      },
    },

    warningTwo: {
      fontFamily: TypographyFamily.NEXA,
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '19px',
      color: ColorPalette.WARNING_RED,

      [customPalette.breakpoints.down('sm')]: {
        fontSize: '12px',
      },
    },
  },
});
